import styled from "styled-components";
import { Portal } from "../StandardUserInterface/Portal";
import { jsx as _jsx } from "react/jsx-runtime";
export const ActionBarPortalId = "action-bar-ui-portal";
/**
 * A Portal to show ActionBar UI.
 */
const ActionBarPortal = _ref => {
  let {
    show
  } = _ref;
  return /*#__PURE__*/_jsx(StyledPortal, {
    id: ActionBarPortalId,
    show: show
  });
};
const StyledPortal = styled(Portal).withConfig({
  displayName: "ActionBarPortal__StyledPortal",
  componentId: "sc-uw0ysa-0"
})(["display:flex;position:absolute;height:56px;visibility:", ";max-width:60%;bottom:", ";left:", "px;right:0;margin:auto;transition:all 0.2s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);"], p => p.show ? "visible" : "hidden", p => p.show ? "130px" : "-56px", p => p.theme.workbenchWidth);
export default ActionBarPortal;